export const pagesObj = {
	"/audit/organization": {
		title: "Организационная структура",
		reference: {
			name: "К структуре",
			link: "/organizations",
		},
		useOrganization: true,
		category: "ORGANIZATION",
		organization: false,
		cols: ["Дата", "Наименование организации", "Действие", "Ответственный"],
	},
	"/audit/employee": {
		title: "Сотрудники",
		reference: {
			name: "К сотрудникам",
			link: "/references/staff",
		},
		category: "EMPLOYEE",
		useOrganization: false,
		organization: false,
		cols: ["Дата", "ФИО сотрудника (объект воздействия)", "Действие", "Ответственный"],
	},
	"/audit/user": {
		title: "Пользователи",
		reference: {
			name: "К пользователям",
			link: "/references/users",
		},
		category: "USER",
		useOrganization: false,
		organization: false,
		cols: ["Дата", "ФИО сотрудника (объект воздействия)", "Действие", "Ответственный"],
	},
	"/audit/role": {
		title: "Настройка ролей",
		reference: {
			name: "К настройке ролям",
			link: "/settings/roles",
		},
		category: "ROLE",
		useOrganization: false,
		organization: false,
		cols: ["Дата", "Пользователь", "Объект воздействия", "Действие", "Ответственный"],
	},
	"/audit/dictionary/okved": {
		title: "Коды ОКВЭД",
		reference: {
			name: "К кодам ОКВЭД",
			link: "/references/codes",
		},
		category: "OKVED",
		useOrganization: false,
		organization: false,
		cols: ["Дата", "Объект воздействия", "Действие", "Ответственный"],
	},

	"/audit/dictionary/activity-area": {
		title: "Сферы деятельности",
		reference: {
			name: "К сферам деятельности",
			link: "/references/areas-activity",
		},
		category: "ACTIVITY_AREA",
		useOrganization: false,
		organization: false,
		cols: ["Дата", "Значение", "Действие", "Ответственный"],
	},
	"/audit/dictionary/ownership-type": {
		title: "Виды владения",
		reference: {
			name: "К видам владения",
			link: "/references/ownerships",
		},
		category: "OWNERSHIP_TYPE",
		useOrganization: false,
		organization: false,
		cols: ["Дата", "Значение", "Действие", "Ответственный"],
	},
	"/audit/dictionary/organization-document-pattern": {
		title: "Шаблоны документов компании",
		reference: {
			name: "К шаблонам",
			link: "/references/document-templates",
		},
		category: "ORGANIZATION_DOCUMENT_PATTERN",
		useOrganization: true,
		organization: true,
		cols: ["Дата", "Название документа", "Организация", "Действие", "Ответственный"],
	},
	"/audit/dictionary/person-status": {
		title: "Статусы сотрудников",
		reference: {
			name: "К статусам",
			link: "/references/statuses-employee",
		},
		category: "PERSON_STATUS",
		useOrganization: false,
		organization: false,
		cols: ["Дата", "Значение", "Действие", "Ответственный"],
	},
	"/audit/construction-object": {
		title: "Объекты капитального строительства",
		reference: {
			name: "К объектам капстроя",
			link: "/references/register_of_kapstroy_objects",
		},
		category: "CONSTRUCTION_OBJECT",
		useOrganization: false,
		organization: false,
		cols: ["Дата", "Объект изменений", "Действие", "Ответственный"],
	},
	"/audit/dictionary/organization-marker": {
		title: "Маркеры организаций",
		reference: {
			name: "К маркерам",
			link: "/references/markers",
		},
		category: "ORGANIZATION_MARKER",
		useOrganization: false,
		organization: false,
		cols: ["Дата", "Значение", "Действие", "Ответственный"],
	},
	"/audit/dictionary/object-status": {
		title: "Статусы объектов",
		reference: {
			name: "К статусам объектов",
			link: "/references/object-statuses",
		},
		category: "OBJECT_STATUS",
		useOrganization: false,
		organization: false,
		cols: ["Дата", "Значение", "Действие", "Ответственный"],
	},
	"/audit/dictionary/object-type": {
		title: "Типы объектов",
		reference: {
			name: "К типам объектов",
			link: "/references/objects",
		},
		category: "OBJECT_TYPE",
		useOrganization: false,
		organization: false,
		cols: ["Дата", "Значение", "Действие", "Ответственный"],
	},
	"/audit/dictionary/inapplicability-reason": {
		title: "Причины неприменимости показателей критериев значимости",
		reference: {
			name: "К причинам",
			link: "/references/reasons_for_the_inapplicability",
		},
		category: "INAPPLICABILITY_REASON",
		useOrganization: false,
		organization: false,
		cols: ["Дата", "Значение", "Действие", "Ответственный"],
	},
	"/audit/dictionary/significance-criteria": {
		title: "Показатели критериев значимости",
		reference: {
			name: "К показателям",
			link: "/references/indicators_of_significance_criteria",
		},
		category: "SIGNIFICANCE_CRITERIA",
		useOrganization: false,
		organization: false,
		cols: ["Дата", "Значение", "Действие", "Ответственный"],
	},

	"/audit/dictionary/business-process-pattern": {
		title: "Шаблоны реестра БП",
		reference: {
			name: "К шаблонам",
			link: "/references/business_process_registry",
		},
		category: "BUSINESS_PROCESS_PATTERN",
		useOrganization: false,
		organization: false,
		cols: ["Дата", "Значение", "Действие", "Ответственный"],
	},
	"/audit/dictionary/threat-model-template": {
		title: "Шаблоны модели угроз",
		reference: {
			name: "К шаблонам",
			link: "/references/threat-pattern",
		},
		category: "THREAT_MODEL_TEMPLATE",
		useOrganization: false,
		organization: false,
		cols: ["Дата", "Значение", "Действие", "Ответственный"],
	},

	"/audit/dictionary/threat-consequence": {
		title: "Последствия реализации угроз",
		reference: {
			name: "К последствиям",
			link: "/references/consequences_of_the_implementation_of_threats",
		},
		category: "THREAT_CONSEQUENCE",
		useOrganization: false,
		organization: false,
		cols: ["Дата", "Значение", "Действие", "Ответственный"],
	},

	"/audit/dictionary/threat": {
		title: "Угрозы",
		reference: {
			name: "К угрозам",
			link: "/references/threats",
		},
		category: "THREAT",
		useOrganization: false,
		organization: false,
		cols: ["Дата", "Объект изменений", "Действие", "Ответственный"],
	},

	"/audit/document": {
		title: "Документы",
		reference: {
			name: "К документам",
			link: "/documents/current/1/folders",
		},
		category: "DOCUMENT",
		useOrganization: true,
		organization: true,
		cols: ["Дата", "Наименование документа", "Действие", "Ответственный"],
	},
	// 'docs-categorized': {
	// 	title: 'Документы',
	// reference: "",
	// useOrganization: true,
	// organization: true,
	// 	cols: [ 'Дата', 'Наименование документа', "Действие", "Ответственный" ],
	// },
	"/audit/categorization/1": {
		title: "1 Создание комиссии по категорированию ОКИИ",
		reference: {
			name: "К шагу",
			link: "/categorization/organizations/1/steps/1.1",
		},
		category: "CATEGORIZATION_STEP_ONE",
		useOrganization: true,
		organization: true,
		cols: ["Дата", "Объект воздействия", "Действие", "Ответственный"],
	},
	"/audit/categorization/2/1": {
		title: "2.1 Добавление бизнес-процессов в реестр",
		reference: {
			name: "К шагу",
			link: "/categorization/organizations/1/steps/2.1",
		},
		category: "CATEGORIZATION_STEP_TWO_ONE",
		useOrganization: true,
		organization: true,
		cols: ["Дата", "Объект воздействия", "Действие", "Ответственный"],
	},
	"/audit/categorization/2/2": {
		title: "2.2 Создание реестра объектов",
		reference: {
			name: "К шагу",
			link: "/categorization/organizations/1/steps/2.2",
		},
		category: "CATEGORIZATION_STEP_TWO_TWO",
		useOrganization: true,
		organization: true,
		cols: ["Дата", "Объект воздействия", "Действие", "Ответственный"],
	},
	"/audit/categorization/3": {
		title: "3 Формирование перечня ОКИИ по результатам актуализации реестра бизнес-процессов и объектов",
		reference: {
			name: "К шагу",
			link: "/categorization/organizations/1/steps/3.1",
		},
		category: "CATEGORIZATION_STEP_THREE",
		useOrganization: true,
		organization: true,
		cols: ["Дата", "Объект воздействия", "Действие", "Ответственный"],
	},
	"/audit/categorization/4/1": {
		title: "4.1 Формирование модели угроз",
		reference: {
			name: "К шагу",
			link: "/categorization/organizations/2/steps/4.1/thread/",
		},
		category: "CATEGORIZATION_STEP_FOUR_ONE",
		useOrganization: true,
		organization: true,
		cols: ["Дата", "Объект воздействия", "Действие", "Ответственный"],
	},
	"/audit/categorization/4/2": {
		title: "4.2 Расчет экономического ущерба",
		reference: {
			name: "К шагу",
			link: "/categorization/organizations/2/steps/4.2/calculate/",
		},
		category: "CATEGORIZATION_STEP_FOUR_TWO",
		useOrganization: true,
		organization: true,
		cols: ["Дата", "Объект воздействия", "Действие", "Ответственный"],
	},
	"/audit/categorization/5": {
		title: "5 Присвоение категории ОКИИ",
		reference: {
			name: "К шагу",
			link: "/categorization/organizations/1/steps/5.1",
		},
		category: "CATEGORIZATION_STEP_FIVE",
		useOrganization: true,
		organization: true,
		cols: ["Дата", "Объект воздействия", "Действие", "Ответственный"],
	},
	"/audit/categorization/6": {
		title: "6 Подготовка и отправка результирующих документов",
		reference: {
			name: "К шагу",
			link: "/categorization/organizations/1/steps/6.1",
		},
		category: "CATEGORIZATION_STEP_SIX",
		useOrganization: true,
		organization: true,
		cols: ["Дата", "Объект воздействия", "Действие", "Ответственный"],
	},
	"/audit/categorization/7": {
		title: "7 Присвоение ОКИИ реестровых номеров ФСТЭК и закрытие процесса",
		reference: {
			name: "К шагу",
			link: "/categorization/organizations/1/steps/7.1",
		},
		category: "CATEGORIZATION_STEP_SEVEN",
		useOrganization: true,
		organization: true,
		cols: ["Дата", "Объект воздействия", "Действие", "Ответственный"],
	},
};
